import { render, staticRenderFns } from "./TasksIndentation.vue?vue&type=template&id=64748948&scoped=true&"
import script from "./TasksIndentation.vue?vue&type=script&lang=js&"
export * from "./TasksIndentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64748948",
  null
  
)

export default component.exports